<template>
  <div>
    <div class="d-flex justify-content-between align-items-center mb-3 flex-wrap">
      <div class="d-flex justify-content-start align-items-center flex-wrap">
        <div class="title">
          {{
            isLangRtl ? formatDate(selected_date, 'MMMM YYYY') : selected_date | moment('MMMM YYYY')
          }}
        </div>
        <SelectorView
          :selected_view="selected_view"
          :selected_date="selected_date"
          @prev="prev"
          @next="next"
        />
      </div>
      <div class="d-flex justify-content-start align-items-center mt-2 mt-md-0">
        <div style="margin-right: 0.75rem">
          <base-button
            variant="secondary"
            @click="openSideBar"
            class="me-2 filter__btn"
            v-b-toggle.sidebar-backdrop
            @mouseenter="filterBtnHovered = true"
            @mouseleave="filterBtnHovered = false"
          >
            <img
              :src="
                filterBtnHovered
                  ? require(`@/assets/images/icons/funnel-simple-bold-svgrepo-com.png`)
                  : require(`@/assets/images/icons/funnel-simple-bold-svgrepo-com.png`)
              "
              alt="filter"
            />
          </base-button>
        </div>

        <div style="margin-right: 0.75rem">
          <base-select
            :remove_default_margin="true"
            :options="view_options"
            field="selected_view"
            :value="selected_view"
            @change-value="setValue"
            :disabled="loading"
            :useI18n="true"
          ></base-select>
        </div>
        <div v-if="false">
          <base-select
            :remove_default_margin="true"
            :options="car_options"
            field="selected_car"
            :value="selected_car"
            @change-value="setValue"
            :disabled="loading"
            :useI18n="true"
          ></base-select>
        </div>
      </div>
    </div>
    <base-spinner v-if="loading" />

    <div v-else>
      <DailyView
        v-if="selected_view === 'daily'"
        :selected_date="selected_date"
        :events="events"
        :event_types="event_types"
        @eventClick="eventClick"
      />
      <WeeklyView
        v-else-if="selected_view === 'weekly'"
        :selected_date="selected_date"
        :events="events"
        :event_types="event_types"
        @eventClick="eventClick"
      />
      <MonthlyView
        v-else-if="selected_view === 'monthly'"
        :selected_date="selected_date"
        :events="events"
        :event_types="event_types"
        @eventClick="eventClick"
      />
      <EventTypes :event_types="event_types" />
      <EventDetailPopup
        v-if="event_detail_modal"
        :event="open_detail_for"
        @toggleEventDetailModal="toggleEventDetailModal"
        @toggleChangeTripStatusModal="toggleChangeTripStatusModal"
      />
      <ChangeTripStatusPopup
        v-if="Boolean(change_trip_status_modal)"
        :selected_id="selected_id"
        :event="open_detail_for"
        @closeModal="toggleChangeTripStatusModal"
        @refreshData="refreshCalendarData"
      />
    </div>
  </div>
</template>

<script>
import SelectorView from './selectorView.vue'
import EventTypes from './eventTypes.vue'
import DailyView from './dailyView.vue'
import WeeklyView from './weeklyView.vue'
import MonthlyView from './monthlyView.vue'
import EventDetailPopup from './eventDetailPopup.vue'
import ChangeTripStatusPopup from './changeTripStatusPopup.vue'
import moment from 'moment'

export default {
  name: 'calendar-component',
  components: {
    SelectorView,
    EventTypes,
    DailyView,
    WeeklyView,
    MonthlyView,
    EventDetailPopup,
    ChangeTripStatusPopup,
  },
  props: ['events', 'loading'],
  emits: ['refreshData', 'getMonth'],
  data() {
    return {
      filterBtnHovered: false,
      selected_date: new Date(),
      view_options: [
        { text: 'daily', value: 'daily' },
        { text: 'weekly', value: 'weekly' },
        { text: 'monthly', value: 'monthly' },
      ],
      car_options: [{ text: 'car-assigned', value: null }],
      selected_view: 'daily',
      selected_car: null,
      event_types: [
        {
          text: this.$t('sales-order'),
          value: 'sales-order',
          background: 'var(--color-19)',
          border: '1px solid var(--color-16)',
        },
        {
          text: this.$t('quotation'),
          value: 'quotation',
          background: 'var(--color-18)',
          border: '1px solid var(--color-22)',
        },
        {
          text: this.$t('draft-sales-order'),
          value: 'draft-sales-order',
          background: 'var(--color-25);',
          border: '1px solid var(--color-26)',
        },
        {
          text: this.$t('waiting-for-approval'),
          value: 'waiting-for-approval',
          background: 'var(--color-48)',
          border: '1px solid var(--color-40)',
        },
        {
          text: this.$t('canceled'),
          value: 'cancelled',
          background: 'var(--color-20)',
          border: '1px solid var(--color-39)',
        },
        // {
        //   text: "Reschedule",
        //   value: "reschedule",
        //   background: "var(--color-18)",
        //   border: "1px solid var(--color-41)",
        // },
      ],
      open_detail_for: null,
      event_detail_modal: false,
      change_trip_status_modal: false,
      selected_id: '',
    }
  },
  methods: {
    setValue(val, field) {
      this[field] = val
      this.$emit('getMonth', this.selected_date, val)
    },
    openSideBar() {
      this.$root.$emit('bv::show::collapse', 'sidebar-backdrop')
    },
    prev() {
      if (this.selected_view === 'daily') {
        let d = new Date(this.selected_date)
        this.selected_date = new Date(d.setDate(d.getDate() - 1))
        this.$emit('getMonth', this.selected_date, this.selected_view)
      } else if (this.selected_view === 'weekly') {
        let d = new Date(this.selected_date)
        this.selected_date = new Date(d.setDate(d.getDate() - 1 * 7))
        this.$emit('getMonth', this.selected_date, this.selected_view)
      } else if (this.selected_view === 'monthly') {
        let d = new Date(this.selected_date)
        this.selected_date = new Date(d.setMonth(d.getMonth() - 1))
        this.$emit('getMonth', this.selected_date, this.selected_view)
      }
    },
    next() {
      if (this.selected_view === 'daily') {
        let d = new Date(this.selected_date)
        this.selected_date = new Date(d.setDate(d.getDate() + 1))
        this.$emit('getMonth', this.selected_date, this.selected_view)
      } else if (this.selected_view === 'weekly') {
        let d = new Date(this.selected_date)
        this.selected_date = new Date(d.setDate(d.getDate() + 1 * 7))
        this.$emit('getMonth', this.selected_date, this.selected_view)
      } else if (this.selected_view === 'monthly') {
        let d = new Date(this.selected_date)
        this.selected_date = new Date(d.setMonth(d.getMonth() + 1))
        this.$emit('getMonth', this.selected_date, this.selected_view)
      }
    },
    eventClick(event) {
      this.open_detail_for = event
      this.event_detail_modal = true
    },
    toggleEventDetailModal() {
      this.event_detail_modal = !this.event_detail_modal
      if (!this.event_detail_modal) {
        this.open_detail_for = null
      }
    },
    toggleChangeTripStatusModal(id) {
      this.selected_id = id
      this.event_detail_modal = false
      this.change_trip_status_modal = !this.change_trip_status_modal
    },
    refreshCalendarData() {
      this.$emit('refreshData')
    },
  },
  watch: {
    selected_date(val) {
      if (
        val &&
        (!this.$route?.query?.date ||
          this.$route?.query?.date !== moment(val).locale('en').format('YYYY-MM-DD'))
      )
        this.$router
          .replace(`/operations/calendar?date=${moment(val).locale('en').format('YYYY-MM-DD')}`)
          .catch(() => {})
    },
  },
  mounted() {
    document.getElementById('main-view').style.background = 'var(--color-01)'

    if (this.$route?.query?.date) {
      this.selected_date = new Date(this.$route.query.date)
    } else if (this.selected_date) {
      this.$router
        .replace(
          `/operations/calendar?date=${moment(this.selected_date)
            .locale('en')
            .format('YYYY-MM-DD')}`
        )
        .catch(() => {})
    }
  },
  destroyed() {
    document.getElementById('main-view').style.background = 'var(--color-21)'
  },
  i18n: {
    messages: {
      en: require('@/services/i18n/locales/en/reservationOperations.json'),
      ar: require('@/services/i18n/locales/ar/reservationOperations.json'),
    },
  },
}
</script>

<style lang="scss" scoped>
.title {
  font-weight: 700;
  font-size: 24px;
  color: var(--color-17);
  margin-right: 0.75rem;
}
</style>
